// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-datetime {
  max-width: 100%;
}

ion-grid {
  margin: 15px 25px;
}

.border {
  --padding-start: 0px;
  border: 1px solid black;
}

.row-hover {
  cursor: pointer;
}

.hyperlink {
  color: #0063CF;
  text-decoration: none;
  cursor: pointer;
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/rewards/bonuses/past-bonuses/past-bonuses.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;AACJ;;AAEA;EACI,iBAAA;AACJ;;AAEA;EACI,oBAAA;EACA,uBAAA;AACJ;;AAEA;EACI,eAAA;AACJ;;AAEA;EACI,cAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;AACJ","sourcesContent":["ion-datetime {\r\n    max-width: 100%;\r\n}\r\n\r\nion-grid {\r\n    margin: 15px 25px;\r\n}\r\n\r\n.border {\r\n    --padding-start: 0px;\r\n    border: 1px solid black;\r\n}\r\n\r\n.row-hover {\r\n    cursor: pointer;\r\n}\r\n\r\n.hyperlink{\r\n    color: #0063CF;\r\n    text-decoration: none;\r\n    cursor: pointer;\r\n    font-weight: 600;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
